export const DEBOUNCE_TIMER = 800;
